import type { SerpFilterOptionView } from '../model/types';

export function getInlineFilterOptions(
  options: readonly SerpFilterOptionView[],
  pinnedKeys: ReadonlySet<string>,
  limit: number,
): SerpFilterOptionView[] {
  const pinnedOptions = options.filter((option) => pinnedKeys.has(option.key));
  const restOptions = options.filter((option) => !pinnedKeys.has(option.key));
  const visibleOptions = [...pinnedOptions, ...restOptions.slice(0, Math.max(limit - pinnedOptions.length, 0))];
  const visibleKeys = new Set(visibleOptions.map((option) => option.key));
  const hiddenSelectedOptions = options.filter((option) => option.selected && !visibleKeys.has(option.key));

  return [...visibleOptions, ...hiddenSelectedOptions];
}
